import React, { useState } from 'react';
import { Produto, Categoria, AdicionalCategoria, AdicionalItem, Bairro } from '../../types';
import { produtosService } from '../../services/produtos.service';

interface AdminModaisProps {
  isEditing: boolean;
  setIsEditing: (open: boolean) => void;
  currentProduto: Partial<Produto> | null;
  setCurrentProduto: (prod: any) => void;
  
  isEditingCategoria: boolean;
  setIsEditingCategoria: (open: boolean) => void;
  currentCategoria: Partial<Categoria> | null;
  setCurrentCategoria: (cat: any) => void;
  
  isEditingAdicionalCat: boolean;
  setIsEditingAdicionalCat: (open: boolean) => void;
  currentAdicionalCat: Partial<AdicionalCategoria> | null;
  setCurrentAdicionalCat: (cat: any) => void;
  
  isEditingAdicionalItem: boolean;
  setIsEditingAdicionalItem: (open: boolean) => void;
  currentAdicionalItem: Partial<AdicionalItem> | null;
  setCurrentAdicionalItem: (item: any) => void;
  
  isEditingBairro: boolean;
  setIsEditingBairro: (open: boolean) => void;
  currentBairro: Partial<Bairro> | null;
  setCurrentBairro: (bairro: any) => void;
  
  isCreatingEmpresa: boolean;
  setIsCreatingEmpresa: (open: boolean) => void;
  newEmpresaData: any;
  setNewEmpresaData: (data: any) => void;
  
  handleSaveProduto: (e: React.FormEvent) => void;
  handleSaveCategoria: (e: React.FormEvent) => void;
  handleSaveAdicionalCat: (e: React.FormEvent) => void;
  handleSaveAdicionalItem: (e: React.FormEvent) => void;
  handleSaveBairro: (e: React.FormEvent) => void;
  handleCreateEmpresa: (e: React.FormEvent) => void;
  
  isUpdating: boolean;
  categorias: Categoria[];
  adicionaisCats: AdicionalCategoria[];
  isDemo?: boolean;
}

export const AdminModais: React.FC<AdminModaisProps> = ({
  isEditing, setIsEditing, currentProduto, setCurrentProduto,
  isEditingCategoria, setIsEditingCategoria, currentCategoria, setCurrentCategoria,
  isEditingAdicionalCat, setIsEditingAdicionalCat, currentAdicionalCat, setCurrentAdicionalCat,
  isEditingAdicionalItem, setIsEditingAdicionalItem, currentAdicionalItem, setCurrentAdicionalItem,
  isEditingBairro, setIsEditingBairro, currentBairro, setCurrentBairro,
  isCreatingEmpresa, setIsCreatingEmpresa, newEmpresaData, setNewEmpresaData,
  handleSaveProduto, handleSaveCategoria, handleSaveAdicionalCat, handleSaveAdicionalItem, handleSaveBairro, handleCreateEmpresa,
  isUpdating, categorias, adicionaisCats, isDemo = false
}) => {
  const [uploading, setUploading] = useState(false);

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isDemo) return;
    const file = e.target.files?.[0];
    if (file && currentProduto) {
      setUploading(true);
      try {
        const url = await produtosService.uploadImage(file);
        setCurrentProduto({ ...currentProduto, imagem_url: url });
      } catch (err: any) {
        alert("Erro no upload: " + err.message);
      } finally {
        setUploading(false);
      }
    }
  };

  const modalClass = "relative bg-white w-full max-w-xl sm:rounded-[2.5rem] p-6 sm:p-10 shadow-2xl space-y-6 max-h-screen sm:max-h-[90vh] overflow-y-auto custom-scrollbar animate-slide-up sm:animate-fade-in";

  return (
    <>
      {/* Modal Produto */}
      {isEditing && currentProduto && (
         <div className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center sm:p-6">
           <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-md" onClick={() => setIsEditing(false)}></div>
           <form onSubmit={handleSaveProduto} className={modalClass}>
             <div className="flex justify-between items-center">
                <h3 className="text-xl sm:text-2xl font-black text-slate-900 tracking-tight">Editar Produto</h3>
                <button type="button" onClick={() => setIsEditing(false)} className="sm:hidden p-2 bg-slate-100 rounded-full"><svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M6 18L18 6M6 6l12 12" /></svg></button>
             </div>
             <div className="space-y-4">
                <label className="flex items-center gap-2 cursor-pointer bg-slate-50 px-3 py-2 rounded-xl border border-slate-200 w-fit">
                  <input type="checkbox" disabled={isDemo} className="w-4 h-4 accent-orange-600" checked={!!currentProduto.ativo} onChange={e => setCurrentProduto({...currentProduto, ativo: e.target.checked})} />
                  <span className="text-[10px] font-black uppercase text-slate-500">Produto Ativo</span>
                </label>
                <div><label className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 block">Nome</label><input required disabled={isDemo} className="w-full px-5 py-4 bg-slate-50 border border-slate-200 rounded-2xl font-bold outline-none focus:border-orange-600" value={currentProduto.nome} onChange={e => setCurrentProduto({...currentProduto, nome: e.target.value})} /></div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div><label className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 block">Preço</label><input type="number" step="0.01" required disabled={isDemo} className="w-full px-5 py-4 bg-slate-50 border border-slate-200 rounded-2xl font-bold outline-none focus:border-orange-600" value={currentProduto.preco} onChange={e => setCurrentProduto({...currentProduto, preco: parseFloat(e.target.value)})} /></div>
                  <div><label className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 block">Categoria</label><select disabled={isDemo} className="w-full px-5 py-4 bg-slate-50 border border-slate-200 rounded-2xl font-bold outline-none focus:border-orange-600" value={currentProduto.categoria} onChange={e => setCurrentProduto({...currentProduto, categoria: e.target.value})}>{categorias.map(cat => <option key={cat.id} value={cat.nome}>{cat.nome}</option>)}</select></div>
                </div>
                <div>
                  <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 block">Foto do Produto</label>
                  <div className="flex flex-col sm:flex-row items-center gap-4 p-4 bg-slate-50 border border-slate-200 rounded-2xl">
                    <div className="w-20 h-20 rounded-xl bg-slate-200 overflow-hidden flex items-center justify-center shrink-0">
                      {currentProduto.imagem_url ? <img src={currentProduto.imagem_url} className="w-full h-full object-cover" /> : <svg className="w-8 h-8 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>}
                    </div>
                    <div className="flex-1 text-center sm:text-left">
                      <input type="file" accept="image/*" onChange={handleFileChange} className="hidden" id="product-image-upload" disabled={isDemo} />
                      <label htmlFor="product-image-upload" className={`inline-flex items-center gap-2 bg-slate-900 text-white px-5 py-2.5 rounded-xl text-[10px] font-black uppercase tracking-widest hover:bg-orange-600 transition-all ${isDemo ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'}`}>
                        {uploading ? 'Enviando...' : 'Trocar Foto'}
                      </label>
                      <p className="text-[9px] text-slate-400 font-bold mt-2">JPG, PNG. Recomendado 800x800px.</p>
                    </div>
                  </div>
                </div>
                <div><label className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 block">Descrição</label><textarea disabled={isDemo} className="w-full px-5 py-4 bg-slate-50 border border-slate-200 rounded-2xl font-bold outline-none focus:border-orange-600" rows={3} value={currentProduto.descricao} onChange={e => setCurrentProduto({...currentProduto, descricao: e.target.value})} /></div>
             </div>
             <button type="submit" disabled={isUpdating || uploading} className="w-full bg-slate-900 text-white py-5 rounded-2xl font-black uppercase text-xs tracking-widest hover:bg-orange-600 transition-all disabled:opacity-50">{isUpdating ? 'Salvando...' : 'Salvar Alterações'}</button>
           </form>
         </div>
      )}

      {/* Modal Categoria */}
      {isEditingCategoria && currentCategoria && (
         <div className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center sm:p-6">
           <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-md" onClick={() => setIsEditingCategoria(false)}></div>
           <form onSubmit={handleSaveCategoria} className={modalClass.replace('max-w-xl', 'max-w-sm')}>
             <h3 className="text-xl font-black text-slate-900 tracking-tight">Categoria</h3>
             <div className="space-y-4">
                <label className="flex items-center gap-2 cursor-pointer bg-slate-50 px-3 py-2 rounded-xl border border-slate-200 w-fit">
                  <input type="checkbox" disabled={isDemo} className="w-4 h-4 accent-orange-600" checked={!!currentCategoria.ativo} onChange={e => setCurrentCategoria({...currentCategoria, ativo: e.target.checked})} />
                  <span className="text-[9px] font-black uppercase text-slate-400">Ativa no menu</span>
                </label>
                <div><label className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 block">Nome</label><input required disabled={isDemo} className="w-full px-5 py-4 bg-slate-50 border border-slate-200 rounded-2xl font-bold outline-none focus:border-orange-600" value={currentCategoria.nome} onChange={e => setCurrentCategoria({...currentCategoria, nome: e.target.value})} /></div>
                <div><label className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 block">Ordem Visual</label><input type="number" required disabled={isDemo} className="w-full px-5 py-4 bg-slate-50 border border-slate-200 rounded-2xl font-bold outline-none focus:border-orange-600" value={currentCategoria.ordem} onChange={e => setCurrentCategoria({...currentCategoria, ordem: parseInt(e.target.value)})} /></div>
             </div>
             <button type="submit" disabled={isUpdating} className="w-full bg-slate-900 text-white py-5 rounded-2xl font-black uppercase text-xs tracking-widest hover:bg-orange-600 transition-all disabled:opacity-50">Salvar Categoria</button>
           </form>
         </div>
      )}

      {/* Outros modais seguem o mesmo padrão de responsividade se necessário... */}
      <style>{`
        @keyframes slide-up { from { transform: translateY(100%); } to { transform: translateY(0); } }
        .animate-slide-up { animation: slide-up 0.3s cubic-bezier(0.16, 1, 0.3, 1); }
      `}</style>
    </>
  );
};